import React, { Component } from 'react'
import Utils from '../../lib/utils'

export default class HtmlComponent extends Component {
  componentDidMount () {
    if (__isBrowser__) {
      if (this.props.data && this.props.data.sourceFiles && this.props.data.sourceFiles.length > 0) {
        this.props.data.sourceFiles.map((item) => {
          Utils.getScript(item)
        })
      }
    }
  }
  render () {
    if (!this.props.data) {
      return ''
    }
    return (
      <div dangerouslySetInnerHTML={{ __html: this.props.data.htmlContent }} />
    )
  }
}
